
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'targetBlank'
})
export class TargetBlankPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    if (!html) {
      return '';
    }

    // Create a temporary div to parse the HTML
    const doc = new DOMParser().parseFromString(html, 'text/html');
    
    // Find all links in the document
    const links = doc.querySelectorAll('a');
    
    // Add target="_blank" to each link
    links.forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer'); // Security best practice
    });
    
    // Get the modified HTML
    const modifiedHtml = doc.body.innerHTML;
    
    // Return sanitized HTML
    return this.sanitizer.bypassSecurityTrustHtml(modifiedHtml);
  }
}